import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useState } from "react";
import { sleep, useMobile, useWidth, useAsync } from "common-frontend-components";
import { postCategoryAssociationsStore } from "../../../../stores/posts/usePostCategoryAssociationsStore";
import { postsStore } from "../../../../stores/posts/postsStore";
import { photosStore } from "../../../../stores/posts/usePhotosStore";
import { GallerySwiperWithNavigation } from "../../../custom/carousels/GallerySwiper";
import { Box, Fade } from "@mui/material";
import { Image } from "../../../custom/images/Image";
import Typography from "@mui/material/Typography";
import { textColor } from "../../../../assets/styles/colors";
import { globalAppConfigStore } from "../../../../stores/appConfig/globalAppConfigStore";
import { wwwLinks } from "../../../../variables/wwwRoutes";
export const useCategoryResponsiveName = (category) => {
    return useMobile() ? category.shortName : category.name;
};
export const ClickToSeeMore = (props) => {
    props = { ...props, ...globalAppConfigStore.useComponent('theme')?.params?.components?.ClickToSeeMore || {} };
    props.sx = { fontSize: '.8rem', color: textColor + '77', position: 'relative', bottom: '3px', ...(props.sx || {}) };
    return (_jsx(Box, { component: 'span', ...props }, void 0));
};
export const useGetGalleryItems = (itemsLimit, category) => {
    const associations = postCategoryAssociationsStore.usePostCategoryAssociations();
    const posts = postsStore.usePosts();
    const photos = photosStore.usePhotos();
    const width = useWidth();
    const sectionWidth = width > 300 ? Math.floor(width / 300) : 1;
    const { sectionItems, items } = useMemo(() => {
        // tslint:disable-next-line:no-shadowed-variable
        const items = [];
        const indexed = [];
        const unindexed = [];
        const categoryPosts = postCategoryAssociationsStore.getCategoryPosts(category.id);
        for (const post of categoryPosts) {
            const i = { photos: photosStore.getPhotosById(post.id) || [], post };
            if (i.photos.length > 0) {
                if (post.index === undefined)
                    unindexed.push(i);
                else
                    indexed.push(i);
            }
        }
        if (category.reverse) {
            // @ts-ignore
            indexed.sort((a, b) => b.post.index - a.post.index);
            // @ts-ignore
            unindexed.sort((a, b) => a.post.created - b.post.created);
        }
        else {
            // @ts-ignore
            indexed.sort((a, b) => a.post.index - b.post.index);
            // @ts-ignore
            unindexed.sort((a, b) => b.post.created - a.post.created);
        }
        if (items.length < itemsLimit) {
            for (const i of indexed) {
                items.push(i);
                if (items.length === itemsLimit)
                    break;
            }
        }
        if (items.length < itemsLimit) {
            for (const i of unindexed) {
                items.push(i);
                if (items.length === itemsLimit)
                    break;
            }
        }
        // tslint:disable-next-line:no-shadowed-variable
        const sectionItems = [[]];
        items.forEach(i => {
            if (sectionItems[sectionItems.length - 1].length === sectionWidth)
                sectionItems.push([]);
            sectionItems[sectionItems.length - 1].push(i);
        });
        return { sectionItems, items };
    }, [associations, posts, photos, category, sectionWidth]);
    const slidesPerView = sectionWidth > items.length ? items.length : sectionWidth;
    return {
        sectionItems,
        items,
        slidesPerView,
    };
};
const useEnterTransition = (delay) => {
    const [enter, setEnter] = useState(false);
    useAsync(async () => {
        await sleep(delay);
        setEnter(true);
    }, []);
    return enter;
};
const getItemUrl = (i) => i.photos.find(p => p.phototype === 'preview')?.url || i.photos[0].url;
export const GalleryCarousel = ({ delay = 0, category, itemsLimit }) => {
    const enter = useEnterTransition(delay);
    const categoryName = useCategoryResponsiveName(category);
    const { sectionItems, items, slidesPerView } = useGetGalleryItems(itemsLimit, category);
    if (sectionItems.length === 1 && sectionItems[0].length === 0)
        return _jsx(_Fragment, {}, void 0);
    return (_jsxs(Box, { sx: { paddingTop: 1, paddingBottom: 3 }, children: [_jsxs(Typography, { sx: { fontSize: '1.5rem', padding: 1, paddingBottom: 1, paddingTop: 0, color: textColor, cursor: 'pointer' }, onClick: () => { wwwLinks.galleryCategory({ 'categoryId': category.id }); }, color: "text.secondary", gutterBottom: true, children: [categoryName, " ", _jsx(ClickToSeeMore, { children: "\u2190  click to see more" }, void 0)] }, void 0), _jsx(GallerySwiperWithNavigation, { slidesPerView: slidesPerView, spaceBetween: 0, style: { height: 174 }, children: items.map((i, index) => _jsx(Fade, { in: enter, timeout: index * 500, children: _jsx(Box, { sx: {
                        // width: '290px',
                        // height: '180px',
                        // padding: '3px 2px',
                        // boxShadow: "0px 4px 6px 2px #000000aa",
                        // borderRadius: 3,
                        }, children: _jsx(Box, { sx: {
                                position: 'relative',
                                right: '0px',
                                width: '100%',
                                height: '100%',
                                transition: '250ms all',
                                // '&:hover': {
                                //   margin: '0 40px',
                                //   transform: 'scale(1.2)',
                                //   right: '29px',
                                //   zIndex: 10,
                                // }
                            }, children: _jsx(Image, { maxWidth: 290 - 6, maxHeight: 180 - 4, 
                                // @ts-ignore
                                src: getItemUrl(i), alt: i.post.title, onClick: () => photosStore.openImageFullViewUrl({ photos: i.photos, index: 0 }) }, void 0) }, void 0) }, void 0) }, i.post.id)) }, void 0)] }, void 0));
};
//# sourceMappingURL=GalleryCarousel.js.map